import { render } from "./ReferAFriend.vue?vue&type=template&id=bf6a1ae8&scoped=true"
import script from "./ReferAFriend.vue?vue&type=script&lang=js"
export * from "./ReferAFriend.vue?vue&type=script&lang=js"

import "./ReferAFriend.vue?vue&type=style&index=0&id=bf6a1ae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6a1ae8"]])

export default __exports__